import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { selector as commonSelector } from '@store/common';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { addOrRule, deleteOrRule, updateOrRule } from '@store/filterContainer/actions';

import FilterRow from './FilterRow';

const selector = createSelector(commonSelector, filterContainerSelector, (common, filterStore) => ({
  features: common.features,
  andRules: filterStore.newFilterPanel.rule,
}));

export default connect(selector, {
  clickOR: addOrRule,
  deleteRule: deleteOrRule,
  onRuleChange: updateOrRule,
})(FilterRow);
